let MainProductPageThumbs = new Swiper('.MainProductPageThumbs', {
    slidesPerView: "auto",
    spaceBetween: 5,
  })

  let MainProductPage = new Swiper('.MainProductPage', {
    slidesPerView: 1.2,
    spaceBetween: 15,
    watchSlidesProgress: true,
    loop: false,
    pagination: {
      el: '.swiper-paginationMainProduct',
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-nextMainProduct",
      prevEl: ".swiper-button-prevMainProduct",
    },
    breakpoints: {
      700: {
        slidesPerView: 1,
        spaceBetween: 50,
      },
    },
    thumbs: {
      swiper: MainProductPageThumbs,
    }
    
  });

  const buttonCoolGrey = document.querySelector('label[for="8263688356066-form-Color-Cool Grey"]');
  const buttonCloudyWhite = document.querySelector('label[for="8263688356066-form-Color-Cloudy White"]')

  buttonCoolGrey.addEventListener("click", function(){
    MainProductPage.slideTo(0);
  })

  buttonCloudyWhite.addEventListener("click", function(){
    MainProductPage.slideTo(1);
  })

  let flexAccording = document.querySelector(".accordion__title")

  if (flexAccording) {
    flexAccording.style.display = "flex";
    flexAccording.style.alignItems = "center";
    flexAccording.style.gap = "20px";
  }